
<template>
  <div class="contractInformation">
    <div class="main" v-if="contractType">
      <div class="top-search">
        <div class="search-item">
          公司名称：
          <div>
            <!-- <el-select v-model="companyValue" placeholder="请选择">
                    <el-option
                    v-for="item in CompanyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select>-->
            <el-autocomplete
              v-model="merchantsid"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              @clear="clearSelect"
              clearable
              placeholder="单行输入"
            ></el-autocomplete>
            <!-- <el-input placeholder="请输入公司名称" v-model="companyValue" clearable></el-input> -->
          </div>
        </div>
        <div class="search-item">
          <el-button type="primary" @click="search" size="small">搜索</el-button>
        </div>
        <div class="search-item">
          <el-button type="primary" @click="reset" plain size="small">重置</el-button>
        </div>
      </div>
      <div class="bottom-table">
        <el-table :data="signingData" border :header-cell-style="{background:'rgb(250, 250, 250)'}" style="width: 100%">
          <el-table-column prop="merchantName" label="公司名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="merchant_id" label="公司ID" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="nameA" label="签约主体" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="contractNo" label="合同编码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="beginDate" label="签约开始时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="endDate" label="签约结束时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="serviceRate" label="服务费率" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="130">
            <template slot-scope="scope">
              <div>
                <el-button @click="handleClick(scope.row)" size="mini" plain>修改签约</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="bottom-pag">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="currentChange">
            </el-pagination>
      </div>-->
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
    <div class="main contractType" v-if="!contractType">
      <div class="title">
        <div class="fanhui" @click="contractType = true">
          <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="qianyue">客户签约</div>
      </div>
      <div class="box1" style="padding: 20px">
        <div class="item" style="padding-left: 50px">
          <span>客户名称：{{signingObj.merchantName}}</span>
          <span>商户ID：{{signingObj.id}}</span>
        </div>
        <div class="item">
          <div class="search-item">
            <span>签约主体：</span>
            <div>
              <el-input placeholder="请输入" v-model="signingObj.nameA" clearable></el-input>
            </div>
          </div>
          <div class="search-item">
            <span>合同编码：</span>
            <div>
              <el-input placeholder="请输入" v-model="signingObj.contractNo" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="search-item">
            <span>签约开始时间：</span>
            <div>
              <el-date-picker
                v-model="signingObj.beginDate"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <!-- <el-input placeholder="请输入" v-model="signingObj.beginDate" clearable></el-input> -->
            </div>
          </div>
          <div class="search-item">
            <span>签约失效时间：</span>
            <div>
              <el-date-picker
                v-model="signingObj.endDate"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <!-- <el-input placeholder="请输入" v-model="signingObj.endDate" clearable></el-input> -->
            </div>
          </div>
          <div class="search-item">
            <span>服务费（%）：</span>
            <div>
              <el-input placeholder="请输入" v-model="signingObj.serviceRate" clearable></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="remind">系统默认设置：专户专用，即该公司绑定的个体工商户仅支持本商户业务开展使用。如若允许其他商户使用，请开通业务合作摄制，并设置关联商户</div>
      <div style="width:100%;margin-top:20px;">
        <el-button type="primary" @click="signingConfirm">&emsp;确认&emsp;</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      companyValue: "",
      merchantsid: "",
      total: null,
      pageSize: 10,
      signingData: [],
      contractType: true,
      signingObj: {},
      CompanyOptions: []
    };
  },
  mounted() {
    this.CompanyOptions =
      JSON.parse(localStorage.getItem("merchantsList")) || [];
    this.signListPost();
  },
  methods: {
    // currentChange(size) {
    //   console.log(size)
    //   this.allListPost(size)
    // },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条aaaaa`);
      this.pageSize = val;
      this.signListPost();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
      this.signListPost(val);
    },
    search() {
      this.signListPost();
    },
    reset() {
      this.companyValue = "";
      this.merchantsid = "";
      this.signListPost();
    },
    signListPost(size) {
       const loading = this.$loading({
        lock: true,
        spinner: 'loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      post(api.signList, {
        currentPage: size || 1,
        pageSize: this.pageSize,
        merchantId: this.merchantsid
      }).then(
        d => {
          console.log(d.status);
            loading.close();
          if (d.status === 0) {
            this.signingData = [];
            console.log(d, "!!!!!!!!!!!!");
            this.total = d.data.count;
            for (let i = 0; i < d.data.rows.length; i++) {
              this.signingData.push(d.data.rows[i]);
            }
          }
        },
        err => {
          //error callback
        }
      );
    },
    // 修改签约
    handleClick(row) {
      console.log(row);
      this.contractType = false;
      this.signingObj = row;
    },
    signingConfirm() {
      console.log(this.signingObj);
      for (var i in this.signingObj) {
        console.log(i, ":", this.signingObj[i]);
        if (this.signingObj[i] == "") {
          this.$message({
            message: "警告，字段不能为空，请按需求填写",
            type: "warning"
          });
          return;
        }
      }
      post(api.merchantSign, this.signingObj).then(
        d => {
          console.log(d.status);
          if (d.status === 0) {
            console.log(d, "??????????????");
            this.contractType = true;
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.signingObj = [];
          } else {
            console.log(d.msg);
          }
        },
        err => {
          //error callback
        }
      );
    },
    clearSelect() {
      this.merchantsid = "";
      this.signListPost();
    },
    handleSelect(item) {
      console.log(item);
      this.merchantsid = item.id;
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    querySearch(queryString, cb) {
      var CompanyOptions = this.CompanyOptions;
      var results = queryString
        ? CompanyOptions.filter(this.createFilter(queryString))
        : CompanyOptions;
      // 调用 callback 返回建议列表的数据
      cb(results);
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.contractInformation {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      height: 52px;
      line-height: 52px;
      margin-bottom: 10px;
      .search-item {
        float: left;
        margin-right: 20px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        div {
          display: inline-block;
          width: 250px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
  }
  .contractType {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .box1 {
      width: 100%;
      min-height: 127px;
      overflow: hidden;
      background: rgba(250, 250, 250, 0.78);
      border-radius: 6px;
      padding: 30px 40px;
      box-sizing: border-box;
      .item {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        line-height: 32px;
        overflow: hidden;
        span {
          display: inline-block;
          width: 295px;
        }
        .search-item {
          margin-top: 17px;
          float: left;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          span {
            display: inline-block;
            width: 121px;
            text-align: right;
          }
          div {
            display: inline-block;
            width: 233px;
          }
        }
      }
    }
    .box2 {
      margin-top: 20px;
      width: 100%;
      height: 213px;
      background: rgba(251, 251, 251, 0.78);
      border-radius: 6px;
      padding: 30px 40px;
      box-sizing: border-box;
      text-align: left;
      .title {
        display: block;
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      .text {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
      }
    }
    .remind {
      width: 100%;
      height: 61px;
      line-height: 61px;
      padding-left: 35px;
      margin-top: 20px;
      box-sizing: border-box;
      background: rgba(255, 250, 227, 1);
      border: 1px solid rgba(255, 166, 61, 1);
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/merchants/client/contractInformation.vue